export default __webpack_public_path__ + "static/media/digiimg3.25fe7b8b.jpg";